import { DriverList } from '@/components/drivers/DriverList';

export function DriversView() {
  return <DriverList />;
}
